export default "__VITE_ASSET__CdlTf3Yl__"